import { useDebounceFn } from "@vueuse/core";
import { MotionInstance } from "@vueuse/motion";

export interface TouchVariantParams {
  motionElement: MotionInstance;
  delay?: number;
  timeout?: number;
}

const useMotionHelpers = () => {
  const setVariant = (motionElement: MotionInstance, variant: string): void => {
    motionElement.variant.value = variant;
  };

  const touchVariant = useDebounceFn(
    ({ motionElement, timeout = 100 }: TouchVariantParams): void => {
      if (!motionElement) return;

      const actualVariant = motionElement.variant.value;
      motionElement.variant.value = "";
      setTimeout(() => {
        motionElement.variant.value = actualVariant;
      }, timeout);
    },
    50
  );

  return {
    setVariant,
    touchVariant,
  };
};

export default useMotionHelpers;
